import "./profilemenudrop.css";
import React, { useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import useOutsideClick from "../../shared/hooks/useOutsideClick";

const ProfileMenuDrop = () => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const close = useCallback(() => setIsOpen(false), []);
  useOutsideClick(wrapperRef, close);

  return (
    <div
      className="profile dropdown"
      onClick={() => setIsOpen((prev) => !prev)}
      ref={wrapperRef}
    >
      <img
        className="profile-pic dropbtn"
        src="https://avatars.githubusercontent.com/u/15109181?v=4"
        alt="profile"
      />
      <div className="profile-hightlight-dropdown">
        <p> Portfolio Website </p>
        <p> Jasur Shukurov </p>
        <p> jasur@shukurov.me </p>
      </div>
      <div
        className={
          isOpen
            ? "profile-details-dropdown dropdown-show"
            : "profile-details-dropdown dropdown-hide"
        }
      >
        <div className="first-detail">
          <img
            src="https://avatars.githubusercontent.com/u/15109181?v=4"
            alt="profile"
          />
          <p className="detail-text"> Jasur Shukurov</p>
          <p className="detail-text"> jasur@shukurov.me </p>
        </div>
        <Link className="second-detail" to="/about">
          <FontAwesomeIcon className="fa-user-plus" icon={faUserPlus} />
          <p> More about me </p>
        </Link>
        <div className="third-detail">
          <a href="https://github.com/jasur-2902"> GitHub</a>
        </div>
      </div>
    </div>
  );
};

export default ProfileMenuDrop;
